module.exports = __webpack_public_path__ + "static/Chicory2-ba54fe09a3c738a3d054d1c1c9545d83.webp";